import StoreSellers from '@/components/pages/admin/store-sellers/StoreSellers';
import StoreSellerCreate from '@/components/pages/admin/store-sellers/StoreSellerCreate';
import StoreSellerEdit from '@/components/pages/admin/store-sellers/StoreSellerEdit';
import StoreSellerDelete from '@/components/pages/admin/store-sellers/StoreSellerDelete';
import store from '@/store/index';
import {
  STORE_SELLER_VIEW_ROLES,
  storeManagerClientId,
} from '@/utils/store-seller-routes';

const storeSellersMeta = {
  roles: STORE_SELLER_VIEW_ROLES,
};

function managerClientId() {
  const user = store.state.temporaryUser || store.state.user;
  return storeManagerClientId(user);
}

function redirectToClientStoreSellers() {
  const clientId = managerClientId();
  return clientId
    ? { name: 'client-store-sellers', params: { id: String(clientId) } }
    : { name: 'admin-home' };
}

const storeSellersRoutes = [
  {
    path: '/admin/config/clients/:id/boutiques/vendeurs',
    name: 'client-store-sellers',
    component: StoreSellers,
    meta: {
      title: 'store-sellers',
      icon: 'collaboration',
      ...storeSellersMeta,
    },
  },
  {
    path: '/admin/config/clients/:id/boutiques/vendeurs/nouveau',
    name: 'client-store-seller-create',
    component: StoreSellerCreate,
    meta: storeSellersMeta,
  },
  {
    path: '/admin/config/clients/:id/boutiques/vendeurs/:sellerId/modifier',
    name: 'client-store-seller-edit',
    component: StoreSellerEdit,
    meta: storeSellersMeta,
  },
  {
    path: '/admin/config/clients/:id/boutiques/vendeurs/:sellerId/supprimer',
    name: 'client-store-seller-delete',
    component: StoreSellerDelete,
    meta: storeSellersMeta,
  },
  {
    path: '/admin/boutique/vendeurs',
    name: 'store-sellers',
    redirect: redirectToClientStoreSellers,
    meta: {
      title: 'store-sellers',
      icon: 'collaboration',
      ...storeSellersMeta,
    },
  },
  {
    path: '/admin/boutique/vendeurs/nouveau',
    name: 'store-seller-create',
    redirect: () => {
      const clientId = managerClientId();
      return clientId
        ? { name: 'client-store-seller-create', params: { id: String(clientId) } }
        : { name: 'admin-home' };
    },
  },
  {
    path: '/admin/boutique/vendeurs/:sellerId/modifier',
    name: 'store-seller-edit',
    redirect: (to) => {
      const clientId = managerClientId();
      return clientId
        ? {
            name: 'client-store-seller-edit',
            params: { id: String(clientId), sellerId: to.params.sellerId },
          }
        : { name: 'admin-home' };
    },
  },
  {
    path: '/admin/boutique/vendeurs/:sellerId/supprimer',
    name: 'store-seller-delete',
    redirect: (to) => {
      const clientId = managerClientId();
      return clientId
        ? {
            name: 'client-store-seller-delete',
            params: { id: String(clientId), sellerId: to.params.sellerId },
          }
        : { name: 'admin-home' };
    },
  },
];

export default storeSellersRoutes;
